import { ButtonTriggerEvent } from '../../../common/components';

export class ShowInfoModalActions {
  confirm: (event: ButtonTriggerEvent) => void;
  cancel?: () => void;
}

export class InfoModalData {
  constructor(title, icons, info, plainText = null, showCopy = false) {
    this.title = title;
    this.icons = icons;
    this.info = info;
    this.plainText = plainText;
    this.showCopy = showCopy;
  }
  title: string;
  info: string[];
  icons: {
    icon: string;
    color: string;
  }[];
  showCopy: boolean;
  plainText: string | null;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.info.modal/show.info.modal.provider.ts